<template>
  <div class="flex">
    <router-link to="/">
      <img class="pointer" src="~@/assets/img/main/logo.svg" alt="logo" />
    </router-link>
    <div>{{ "title" }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
